import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';

function WebDevelopment() {
  const navigate = useNavigate();
  return (
    <div className="service-page">
      <header className="service-header">
        <h1>Web Development</h1>
        <p>Modern web applications: SPAs, SSR, PWAs, and performance-first sites.</p>
      </header>
      <button className="back-button" onClick={() => navigate(-1)}>← Back</button>
      <div className="service-container">
        <section className="service-section">
          <h3>Offerings</h3>
          <ul>
            <li>Responsive websites & single-page applications</li>
            <li>Performance & SEO optimization</li>
            <li>Headless CMS and API integrations</li>
          </ul>
        </section>

        <div className="service-cta">
          <a href="/contact">Start a Web Project</a>
        </div>
      </div>
    </div>
  );
}

export default WebDevelopment;
